"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moduleLocalization = _interopRequireWildcard(require("@eig-builder/module-localization"));

var _withContext = _interopRequireDefault(require("../../helpers/with-context"));

var _animals = _interopRequireDefault(require("../../assets/images/animals.jpg"));

var _business = _interopRequireDefault(require("../../assets/images/business.jpg"));

var _city = _interopRequireDefault(require("../../assets/images/city.jpg"));

var _computer = _interopRequireDefault(require("../../assets/images/computer.jpg"));

var _man = _interopRequireDefault(require("../../assets/images/man.jpg"));

var _nature = _interopRequireDefault(require("../../assets/images/nature.jpg"));

var _woman = _interopRequireDefault(require("../../assets/images/woman.jpg"));

var _work = _interopRequireDefault(require("../../assets/images/work.jpg"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

require("./lang");

require("./style/common-search-terms.scss");

var _hooks = require("../../hooks");

var terms = [{
  term: 'imageSelector.commonSearchTerms.computer',
  searchTerm: 'Computer',
  image: _computer["default"]
}, {
  term: 'imageSelector.commonSearchTerms.work',
  searchTerm: 'Work',
  image: _work["default"]
}, {
  term: 'imageSelector.commonSearchTerms.business',
  searchTerm: 'Business',
  image: _business["default"]
}, {
  term: 'imageSelector.commonSearchTerms.woman',
  searchTerm: 'Woman',
  image: _woman["default"]
}, {
  term: 'imageSelector.commonSearchTerms.man',
  searchTerm: 'Man',
  image: _man["default"]
}, {
  term: 'imageSelector.commonSearchTerms.city',
  searchTerm: 'City',
  image: _city["default"]
}, {
  term: 'imageSelector.commonSearchTerms.nature',
  searchTerm: 'Nature',
  image: _nature["default"]
}, {
  term: 'imageSelector.commonSearchTerms.animals',
  searchTerm: 'Animals',
  image: _animals["default"]
}];

var CommonSearchTerms = function CommonSearchTerms() {
  var _useSearchQuery = (0, _hooks.useSearchQuery)(),
      setSearchQuery = _useSearchQuery.setSearchQuery;

  var localize = (0, _moduleLocalization.useLocalize)();
  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  var classes = (0, _classnames["default"])('common-search-terms', {
    mobile: isMobile
  });
  var classesTerm = (0, _classnames["default"])('common-search-terms--term', {
    mobile: isMobile
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, terms.map(function (term, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: classesTerm,
      onClick: function onClick() {
        return setSearchQuery(term.searchTerm, localize.localize(term.term));
      },
      style: {
        backgroundImage: "url(".concat(term.image, ")"),
        backgroundSize: 'cover'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "overlay-term"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: term.term
    })));
  }));
};

var _default = (0, _withContext["default"])(CommonSearchTerms);

exports["default"] = _default;